import {Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { Field } from '../../interfaces/field';
import { UntypedFormGroup } from '@angular/forms';
import { FieldErrorService } from '../../services/field-error.service';
import {StateService} from "../../services/state.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-select-field',
    templateUrl: './select-field.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./select-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectFieldComponent implements OnInit {
  @Input() config: Field;
  @Input() control: UntypedFormGroup;
  hasErrors = false;

  constructor(
    private translate: TranslateService,
    private errorService: FieldErrorService,
    protected _state: StateService,
  ) { }

  ngOnInit() {

  }

  selectionChanged(event: any) {
    if (event.target.value !== '') {
      this.errorService.removePropertyErrors(this.config.property);
    }
  }

  validityChanged(valid: boolean) {
    this.hasErrors = valid;
  }
}
